module.exports = __webpack_public_path__ + "static/media/hardlopen-voor-bedrijven-solid.0ad5b0bb.svg";